import type { Search_RequestBody } from "@opensearch-project/opensearch/api";
import type { QueryContainer } from "@opensearch-project/opensearch/api/_types/_common.query_dsl";

import { buildSearchQueryFilter } from "./build-search-query-filter";
import {
    ORDER_PRODUCT_SEARCH_SIZE,
    PRODUCT_NAME_SEARCH_FIELDS,
} from "./product-search-constants";

type BuildOrderProductSearchBodyOptions = {
    searchText: string;
    showOutOfStock: boolean;
    size?: number;
};

/** OpenSearch body for admin add-line-item product picker. */
function buildOrderProductSearchBody({
    searchText,
    showOutOfStock,
    size = ORDER_PRODUCT_SEARCH_SIZE,
}: BuildOrderProductSearchBodyOptions): Search_RequestBody {
    const must: QueryContainer[] = [
        {
            term: {
                isHideFromMenu: false,
            },
        },
    ];

    if (!showOutOfStock) {
        must.push({
            range: {
                availableUnits: {
                    gt: 0,
                },
            },
        });
    }

    const textQuery = buildSearchQueryFilter(
        searchText,
        PRODUCT_NAME_SEARCH_FIELDS,
    );

    if (textQuery) {
        must.push(textQuery);
    }

    return {
        size,
        query: {
            bool: {
                must,
            },
        },
    };
}

/** Lookup products by POS id for order line-item name resolution. */
function buildProductIdsSearchBody(posIds: string[]): Search_RequestBody {
    const ids = posIds.map(id => id.trim()).filter(Boolean);

    return {
        size: Math.max(ids.length, 1),
        query: {
            bool: {
                must: [
                    {
                        terms: {
                            id: ids,
                        },
                    },
                ],
            },
        },
    };
}

export { buildOrderProductSearchBody, buildProductIdsSearchBody };
